import {
  toLower,
  pathOr,
  filter,
  equals,
  cond,
  always,
  head,
  gt,
  T,
  length,
} from 'ramda';
import { DEFAULT_HOME_ROOT, PASSWORDLESS_ROUTE } from 'src/route_constants';
import { ADVISOR_DASHBOARD_PRODUCT_TYPE_VISIT } from 'src/features/RBAC/Rules/permissionData';
import { base64Encode } from 'src/utilities/base64';
import { isNotEmpty } from 'src/utilities/hasValue';
import { getQueryParam } from 'src/utilities/queryParams';
import { getMultiplePermissionOptions } from 'src/features/RBAC/permissions';

interface IApplyParams {
  permissions: [];
  username: string;
  loanType: string;
  defaultRoute: string;
}



//return to direct presignup if advisor has permission of single subproduct (Purchase or Refinance)
const makeSingleSubProductUrl = (multiOption: any, username: string) => {
  const subProduct = pathOr('', ['value'], multiOption);
  const productType = toLower(pathOr('', ['loan_type'], multiOption));
  return `${PASSWORDLESS_ROUTE}/${productType}-${subProduct}?advisor=${username}`;
};

/* return to advisor product landing page when  ifthe advisor has more than one subproduct
  Ex: apply/iori-austin
  */
const makeMultipleSubProductUrl = (multiOptions: any) => {
  return `/loanproducts?products=${base64Encode(multiOptions)}`;
};

/*return to advisor product landing page when  ifthe advisor has more than one subproduct with subproduct filter
   Ex:  apply/pam-forest/residentialmortages  */
const makeMultipleSubProductUrlWithLoanType = (
  multiOptions: any,
  loanType: string,
  defaultRoute: string
) => {
  const specificSubproducts = filter(
    (multOption) =>
      equals(toLower(pathOr('', ['loan_type'], multOption)), loanType),
    multiOptions
  );
  return isNotEmpty(specificSubproducts)
    ? makeMultipleSubProductUrl(specificSubproducts)
    : defaultRoute;
};

export const getDefaultRoute = (username: string) => {
  const redirectMeta = getQueryParam(location.search, 'loanData');
  return redirectMeta
    ? `${DEFAULT_HOME_ROOT}?loanData=${redirectMeta}`
    : `${DEFAULT_HOME_ROOT}?advisor=${username}`;
};

// making redirect url based on advisor permissions
export const makeRedirectURL = (dataBag: IApplyParams) => {
  //this will filter the permissions with apply link

  const { permissions, username, loanType, defaultRoute } = dataBag;


  const multiOptions = getMultiplePermissionOptions(permissions, ADVISOR_DASHBOARD_PRODUCT_TYPE_VISIT)

  return cond([
    [
      () => equals(length(multiOptions), 1),
      always(makeSingleSubProductUrl(head(multiOptions), username)),
    ],
    [
      () => gt(length(multiOptions), 1) && isNotEmpty(loanType),
      always(
        makeMultipleSubProductUrlWithLoanType(
          multiOptions,
          loanType,
          defaultRoute
        )
      ),
    ],
    [
      () => gt(length(multiOptions), 1),
      always(makeMultipleSubProductUrl(multiOptions)),
    ],

    [T, always(defaultRoute)],
  ])(length(multiOptions));
};
